import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import { PaymentObject } from '../paymentObject';
import { ConfService } from '../conf.service';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppComponent } from '../app.component';
import { LeftpanelComponent, LoaderWithProgressComponent } from '../leftpanel/leftpanel.component';
import { ExternalLibraryService } from '../razorpayService';
import { AdminEnvironmentHandlerService } from '../admin-environment-handler.service';
import { PartnerSettingsService } from '../partnerSettings/partner-settings.service';
import { Router } from '@angular/router';
import { interval } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';


declare let Razorpay: any;
declare const require: any;
const jsPDF = require('jspdf');

@Component({
    selector: 'app-billing',
    templateUrl: './billing.component.html',
    styleUrls: ['./billing.component.scss']
})
export class BillingComponent implements OnInit {

    intermediateJSONForPayment = {};
    month: any;
    currentMonth: number;
    currentYear: number;
    partner = localStorage.getItem('partner');
    enablePayButton = false;
    data: any;
    months: any;
    // data = {
    //     'isPaid': false,
    //     'month': 0,
    //     'year': 2020,
    //     'taxPercentage': 18,
    //     'paymentRequestId': '',
    //     'monthName': 'January',
    //     'partnerEmailId': 'vikash@inwmail.net',
    //     'partnerId': 'vikasssssh',
    //     'instaMojoId': '',
    //     'id': 19,
    //     'lastComputed': 1579600965366,
    //     'summary': {
    //         'totalAPISCreatedAmount': 169,
    //         'totalAPISUsageAmount': 0,
    //         'totalFileStorageAmount': 0
    //     },
    //     'partnerAccounts': [
    //         {
    //             'accountId': 'vikasssssh',
    //             'accountEmail': 'vikash@inwmail.net',
    //             'accountPhone': '',
    //             'usage': [
    //                 {
    //                     'count': 3,
    //                     'details': [
    //                         {
    //                             'hits': 0,
    //                             'name': 'vikram',
    //                             'version': 'v1',
    //                             'endpoints': [
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 5678,
    //                                     'operation': 'DELETE'
    //                                 },
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 5678,
    //                                     'operation': 'POST'
    //                                 },
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 5678,
    //                                     'operation': 'GET'
    //                                 },
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 5678,
    //                                     'operation': 'PUT'
    //                                 }
    //                             ],
    //                             'minutes': 22712
    //                         },
    //                         {
    //                             'hits': 0,
    //                             'name': 'vik',
    //                             'version': 'v1',
    //                             'endpoints': [
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 29732,
    //                                     'operation': 'DELETE'
    //                                 },
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 29732,
    //                                     'operation': 'POST'
    //                                 },
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 29732,
    //                                     'operation': 'GET'
    //                                 },
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 29732,
    //                                     'operation': 'PUT'
    //                                 }
    //                             ],
    //                             'minutes': 118928
    //                         },
    //                         {
    //                             'hits': 0,
    //                             'name': 'malar',
    //                             'version': 'v1',
    //                             'endpoints': [
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 5679,
    //                                     'operation': 'DELETE'
    //                                 },
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 5679,
    //                                     'operation': 'POST'
    //                                 },
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 5679,
    //                                     'operation': 'GET'
    //                                 },
    //                                 {
    //                                     'hits': '-',
    //                                     'minutes': 5679,
    //                                     'operation': 'PUT'
    //                                 }
    //                             ],
    //                             'minutes': 22716
    //                         }
    //                     ],
    //                     'apiType': 'DATA_ACCESS',
    //                     'hits': 0,
    //                     'minutes': 164356
    //                 },
    //                 {
    //                     'count': 2,
    //                     'details': [
    //                         {
    //                             'hits': 0,
    //                             'name': 'malar1',
    //                             'connectedMinutes': 5674,
    //                             'version': 'v1'
    //                         },
    //                         {
    //                             'hits': 0,
    //                             'name': 'vik1',
    //                             'connectedMinutes': 29732,
    //                             'version': 'v1'
    //                         }
    //                     ],
    //                     'apiType': 'BUSINESS_LOGIC',
    //                     'hits': 0,
    //                     'minutes': 35406
    //                 }
    //             ],
    //             'apiCreated': [
    //                 {
    //                     'amount': 80,
    //                     'count': 8,
    //                     'details': [
    //                         {
    //                             'endpoints': [
    //                                 {
    //                                     'cost': 10,
    //                                     'operation': 'GET'
    //                                 },
    //                                 {
    //                                     'cost': 10,
    //                                     'operation': 'PUT'
    //                                 },
    //                                 {
    //                                     'cost': 10,
    //                                     'operation': 'POST'
    //                                 },
    //                                 {
    //                                     'cost': 10,
    //                                     'operation': 'DELETE'
    //                                 }
    //                             ],
    //                             'amount': 40,
    //                             'name': 'vikram',
    //                             'version': 'v1'
    //                         },
    //                         {
    //                             'endpoints': [
    //                                 {
    //                                     'cost': 10,
    //                                     'operation': 'GET'
    //                                 },
    //                                 {
    //                                     'cost': 10,
    //                                     'operation': 'PUT'
    //                                 },
    //                                 {
    //                                     'cost': 10,
    //                                     'operation': 'POST'
    //                                 },
    //                                 {
    //                                     'cost': 10,
    //                                     'operation': 'DELETE'
    //                                 }
    //                             ],
    //                             'amount': 40,
    //                             'name': 'malar',
    //                             'version': 'v1'
    //                         }
    //                     ],
    //                     'apiType': 'DATA_ACCESS'
    //                 },
    //                 {
    //                     'amount': 89,
    //                     'count': 1,
    //                     'details': [
    //                         {
    //                             'amount': 89,
    //                             'name': 'malar1',
    //                             'version': 'v1'
    //                         }
    //                     ],
    //                     'apiType': 'BUSINESS_LOGIC'
    //                 }
    //             ],
    //             'fileStorage': 0.002490597777068615
    //         }
    //     ],
    //     'phoneNumber': '',
    //     'GSTNumber': '',
    //     'PANNumber': '',
    //     'address2': '',
    //     'address1': '',
    //     'chartDetails': {
    //         'fileStorageTotalAmount': {
    //             'amount': 0,
    //             'percentage': 0
    //         },
    //         'APIsUsageTotalAmount': {
    //             'amount': 0,
    //             'percentage': 0
    //         },
    //         'TotalAmount': 169,
    //         'APIsCreatedTotalAmount': {
    //             'amount': 169,
    //             'percentage': 100
    //         }
    //     },
    //     'pdfInvoiceDetails': {
    //         'totalBusinessLogicAPISCreated': 1,
    //         'totalDataAccessAPISCreatedAmount': 80,
    //         'totalBusinessLogicAPISCreatedAmount': 89,
    //         'totalDataAccessAPISCreated': 8,
    //         'totalBusinessLogicAPISHits': 0,
    //         'totalAPISHits': 0,
    //         'totalDataAccessAPISHits': 0,
    //         'totalFileStorage': 0.002490597777068615,
    //         'totalAPISCreatedAmount': 169,
    //         'totalBusinessLogicAPISConnectedMinutes': 35406,
    //         'totalAPISConnectedMinutes': 199762,
    //         'totalDataAccessAPISConnectedMinutes': 164356
    //     },
    //     'billingDetails': {
    //         'fileStorageAmount': {
    //             'amount': 0,
    //             'totalFileStorage': 0.002490597777068615,
    //             'description': 'First 50 TB / Month\t$0.023 per GB'
    //         },
    //         'hitsTotalAmount': {
    //             'totalAPISHits': 0,
    //             'amount': 0,
    //             'totalAPISHitsAfterFreeTier': 0
    //         },
    //         'billAmount': 169,
    //         'totalAPISCreatedAmount': 169,
    //         'connectedMinutesTotalAmount': {
    //             'amount': 0,
    //             'totalAPISConnectedMinutesAfterFreeTier': 0,
    //             'totalAPISConnectedMinutes': 199762
    //         },
    //         'isMinutes': false,
    //         'isHits': false
    //     },
    //     'totalBill': 199.42,
    //     'tax': 30.42,
    //     'subTotalBill': 169
    // };
    // months = [
    //     {
    //         'month': 0,
    //         'year': 2020,
    //         'monthName': 'January'
    //     },
    //     {
    //         'month': 1,
    //         'year': 2020,
    //         'monthName': 'February'
    //     }
    // ];
    paymentObject: PaymentObject = {} as PaymentObject;
    errorMessage: any;
    currentData: any;
    loading = false;
    subtotalBill: any;
    subTotalAfterDiscount: any;
    discount: any;
    selectedView = 0;
    paymentLoading = false;
    paymentLoadingId = 0;

    public barChartOptions = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    public barChartLabels = ['API Usage', 'Storage'];
    public chartType = 'doughnut';
    public barChartLegend = true;
    chartAPICreated: any;
    chartAPIUsage: any;
    // chartFileStorage: any;
    // chartDataStorage: any;
    chartStorage: any;
    chartInfrastructure: any;
    total: any;
    totals: any;
    date: any;
    lastUpdatedON: any;
    barChartData: any;
    captchaKey = '6LeiA80UAAAAAK-P15G3dY3V_KOkzTZrUG4NLAWj';
    captcha: any;
    fileStorage: any;
    coupons: any;
    selectedCoupon: any;
    creditPromoCode: any;
    loadingCredit = false;
    payloadForSelectedMonth: any;
    invoices: any;
    payments: any;
    creditsData: any;
    invoiceId: any;
    isCreditApplied: any = false;
    creditBalanceApplied: any = 0;
    RAZORPAY_OPTIONS: any = {
        key: 'rzp_live_EW9ayMsN7si7t4',
        amount: '',
        name: 'apiplatform.io',
        order_id: '',
        description: '',
        image:
            'https://apiplatform.io/assets/images/navbar/logo.svg',
        prefill: {
            name: '',
            email: '',
            contact: '',
            method: ''
        },
        modal: {},
        theme: {
            color: '#0096C5'
        }
    };
    stripePaymentLink = '';
    stripeSessionId: any;

    constructor(private _snackBar: MatSnackBar,
        public platform: LeftpanelComponent,
        private confPost: ConfService,
        private appComp: AppComponent,
        private Urlroute: ActivatedRoute,
        private razorpayService: ExternalLibraryService,
        private cd: ChangeDetectorRef,
        public router: Router,
        private route: ActivatedRoute,
        private adminEnvironmenthandler: AdminEnvironmentHandlerService,
        private partnerSettingsService: PartnerSettingsService, public dialog: MatDialog) {
    }

    paymentHandler: any = null;

    async getBillingData(partner, payload) {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        await this.confPost.getBillingSpan(partner).toPromise().then(response => {
            // console.log('BillingSpan', response);
            loaderDialog.close();
            this.months = response;
        }, error => {
            loaderDialog.close();
            if (error['status'] === 0) {
                this.errorMessage = '0';
            } else if (error['status'] === 500) {
                this.errorMessage = '0';
            }
        });

        this.getBillingInvoiceData(payload);
    }

    redirect(route: string) {
        this.router.navigate([route]);
    }

    setData() {
        this.confPost.getCoupons(this.partner).toPromise().then(response => {
            // console.log('coupons', response);
            this.coupons = response;
            this.coupons.push({ code: 'DO NOT APPLY COUPON' });
        }, error => {
            // this.platform.handleErrorGracefully(error, 'Error while retrieving the coupons. Please try after sometime.');
        });

        this.Urlroute.queryParams
            .subscribe(params => {
                if (params.payment_id && params.payment_request_id) {
                    this.intermediateJSONForPayment['type'] = 'getPaymentRequestDetails';
                    this.intermediateJSONForPayment['payment_id'] = params.payment_request_id;
                    // this.intermediateJSONForPayment['partnerEmailId'] = this.data.body.partnerEmailId;
                    this.intermediateJSONForPayment['instaMojoId'] = params.payment_id;

                    this.confPost.payment(this.intermediateJSONForPayment).subscribe(response => {
                        if (response['response'] === 'success') {
                            this.platform.openSnackBar('Payment has been processed successfully', 'Success', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        } else if (response['response'] === 'failure') {
                            this.platform.openSnackBar('Error in payment. Please try again after sometime', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    }, error => {
                        this.platform.handleErrorGracefully(error, 'Error while making payment. Please try after sometime.');
                    }
                    );
                }
            }, error => {
                this.platform.openSnackBar('Error while making payment. Please try after sometime or contact support@apiplatform.io', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });


        this.getInvoiceData();
        this.getCreditsData();
        this.getPaymentData();
    }

    creditAdded(event) {
        if (event.creditAdded) {
            this.getCreditsData();
        }
    }

    initialize() {
        const partnerSettingsSubscription = interval(500).subscribe((async x => {
            if (this.partnerSettingsService.hasPartnerSettingsDataSet()) {
                partnerSettingsSubscription.unsubscribe();
                let environmentData = this.partnerSettingsService.environment;
                if (!environmentData.name.includes('admin')) {
                    this.redirect('/console');
                } else {
                    this.setData();
                }
                this.adminEnvironmenthandler.onEnvironmentChange.subscribe(async env => {
                    this.partnerSettingsService.changeEnvironment();
                    environmentData = this.partnerSettingsService.environment;
                    if (!environmentData.name.includes('admin')) {
                        this.redirect('/console');
                    } else {
                        this.setData();
                    }
                });
            }
        }));
    }

    ngOnInit() {
        this.appComp.currentPageTitle = 'Billing Management';
        this.razorpayService
            .lazyLoadLibrary('https://checkout.razorpay.com/v1/checkout.js')
            .subscribe();
        // this.confPost.getCaptchaSiteKey().subscribe(response => {
        //     if (response && response[0]) {
        //         this.captchaKey = response[0]['value'];
        //     }
        // });

        this.route.queryParams
            .subscribe(async params => {

                if (params.session_id && params.session_id != null) {
                    this.stripeSessionId = params.session_id;
                    // console.log(this.stripeSessionId);
                    const payload = {
                        'paymentId': this.stripeSessionId,
                        'invoiceId': this.invoiceId,
                        'partner': localStorage.getItem('partner'),
                        'partnerEmail': localStorage.getItem('signInEmail'),
                        'paymentType': 'Stripe',
                        'isCreditApplied': this.isCreditApplied,
                        'creditBalanceApplied': this.creditBalanceApplied
                    };
                    this.updateInvoice(payload);
                }
                if (params.month && params.month != null && params.year && params.year != null) {
                    const payload = {
                        'month': params.month,
                        'year':  params.year,
                        'partner': localStorage.getItem('partner')
                    };

                    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'
                    ];

                    const monthName = monthNames[params.month];
                    this.currentMonth = params.month;
                    this.currentYear = params.year;
                    this.currentData = monthName + ' ' + this.currentYear;
                    this.getBillingData(localStorage.getItem('partner'), payload);
                } else {
                    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'
                    ];

                    const dateObj = new Date();
                    const month = dateObj.getUTCMonth();
                    const year = dateObj.getUTCFullYear();

                    const monthName = monthNames[dateObj.getMonth()];

                    this.currentMonth = month;
                    this.currentYear = year;
                    this.currentData = monthName + ' ' + this.currentYear;

                    const payload = {
                        'month': month,
                        'year': year,
                        'partner': localStorage.getItem('partner')
                    };
                    this.getBillingData(localStorage.getItem('partner'), payload);
                }
            });

        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        this.initialize();
        this.invokeStripe();
    }

    getInvoiceData() {
        const payload = {
            email: localStorage.getItem('signInEmail')
        };
        this.confPost.getInvoiceByEmail(payload).subscribe(res => {
            // console.log('Invoices', res);
            const temp: any = res;
            const temp1: any = temp.sort((a, b) => (a.month > b.month) ? 1 : ((b.month > a.month) ? -1 : 0));
            const temp2: any = temp1.sort((a, b) => (a.year > b.year) ? 1 : ((b.year > a.year) ? -1 : 0));
            if (temp) {
                this.invoices = temp2.reverse();
            }
        }, err => {
            this.platform.openSnackBar('Error while fetching invoices. Please try after sometime.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    getPaymentData() {
        const payload = {
            partner: localStorage.getItem('partner')
        };
        this.confPost.getPaymentHistoryForPartner(payload).subscribe(res => {
            const temp: any = res;
            if (temp.length > 0) {
                this.payments = res;
            } else {
                this.payments = [];
            }
        }, err => {
            this.platform.openSnackBar('Error while fetching payments history. Please try after sometime.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    getCreditsData() {
        const payload = {
            partner: localStorage.getItem('partner')
        };
        this.confPost.getCreditsForPartner(payload).subscribe(res => {
            // console.log('Credits', res);
            const temp: any = res;
            if (temp.length > 0) {
                this.creditsData = res;
            } else {
                this.creditsData = [{
                    'account': localStorage.getItem('partner'),
                    'creditAuditLogs': [],
                    'creditBalance': 0.00,
                    'creditUsed': 0.00,
                    'partner': localStorage.getItem('partner')
                }];
            }
        }, err => {
            this.platform.openSnackBar('Error while fetching credits. Please try after sometime.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    getDate(monthName: any, year: any) {
        if (monthName !== '' && monthName !== undefined && monthName !== null) {
            return monthName.substring(0, 3) + '-' + year;
        }
        return monthName + '-' + year;
    }

    getBillingStatus(isPaid, totalBill) {
        if (totalBill === 0) {
            return 'NA';
        } else if (totalBill > 0 && isPaid) {
            return 'Paid';
        } else {
            return 'Not Paid';
        }
        return 'Not Paid';
    }

    resolved(captchaResponse: string) {
        this.captcha = captchaResponse;
    }

    sendPromoCode() {
        // if (this.couponCode !== undefined && this.couponCode !== '') {
        //     if (this.captcha !== null && this.captcha !== undefined) {
        //         this.captcha = null;
        //     } else {
        //         this._snackBar.open('Perform captcha action to proceed', 'Error', {
        //             duration: 5000,
        //             verticalPosition: 'top',
        //             horizontalPosition: 'center'
        //         });
        //     }
        // } else {
        //     this._snackBar.open('Please provide a coupon code to proceed', 'Error', {
        //         duration: 5000,
        //         verticalPosition: 'top',
        //         horizontalPosition: 'center'
        //     });
        // }
        if (!this.data.body.isCreditsApplied) {
            // if (!this.data.body.isCouponApplied) {
            if (!this.data.body.isPaid) {
                if (this.selectedCoupon) {
                    if (this.selectedCoupon.code !== 'DO NOT APPLY COUPON') {
                        const bodyID = this.data.body.id;
                        this.data = undefined;
                        this.confPost.applyCoupon(bodyID, this.selectedCoupon.id).toPromise().then(response => {
                            // console.log('Apply coupons', response);
                            if (response.status === 200) {
                                if (response.body !== null) {
                                    this.data = response;
                                } else {
                                    this.platform.openSnackBar('Error while applying coupon. Please try after sometime.', 'Error', {
                                        duration: 5000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                }
                            } else {
                                this.platform.openSnackBar('Error while applying coupon. Please try after sometime.', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }
                        }, error => {
                            this.getBillingInvoiceData(this.payloadForSelectedMonth);
                            this.platform.handleErrorGracefully(error, 'Error while applying coupon. Please try after sometime.');
                        });
                    } else {
                        this.getBillingInvoiceData(this.payloadForSelectedMonth);
                    }
                } else {
                    alert('Please select a coupon code to avail your discount');
                }
            } else {
                alert('Bill has already been paid for this month');
            }
            // } else {
            //     alert('Coupon has already been applied for this month');
            // }
        } else {
            alert('Credits has already been applied. Cannot apply coupon');
        }
    }

    applyCredits() {
        if (this.creditPromoCode !== undefined && this.creditPromoCode !== '') {
            const payload = {
                'code': this.creditPromoCode,
                'partner': localStorage.getItem('partner'),
                'timestamp': Date.now()
            };
            this.loadingCredit = true;
            this.confPost.applyCredit(payload).subscribe(res => {
                // console.log(res);
                this.loadingCredit = false;
                this.creditPromoCode = '';
                if (res['message'] === 'Credits added') {
                    this.platform.openSnackBar(res['message'], 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                } else {
                    this.platform.openSnackBar(res['message'], 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }

                this.getCreditsData();
                this.selectedView = 1;
            }, err => {
                this.platform.openSnackBar('Error while adding credits. Please try after sometime.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loadingCredit = false;
                this.selectedView = 1;
            });
        } else {
            this.platform.openSnackBar('Provide correct promotion code.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    toggle(ev) {
        $(ev.target).toggleClass('fa-chevron-right fa-chevron-down');
    }

    payBill() {
        this.paymentObject['type'] = 'paymentRequests';
        this.paymentObject['month'] = this.data.body.month;
        this.paymentObject['year'] = this.data.body.year;
        this.paymentObject['purpose'] = 'Payment for the month ' + this.data.body.month + this.data.body.year;
        this.paymentObject['totalAmount'] = this.data.body.totalBill;
        this.paymentObject['partner'] = this.data.body.partner;
        this.paymentObject['partnerEmailId'] = this.data.body.partnerEmailId;
        this.paymentObject['partnerPhoneNumber'] = '';
        this.confPost.payment(this.paymentObject).subscribe(response => {
            if (response['success']) {
                window.location.href = response['payment_request']['longurl'];
            }
        });
    }

    payBill1(item) {
        this.paymentObject['type'] = 'paymentRequests';
        this.paymentObject['month'] = item.month;
        this.paymentObject['year'] = item.year;
        this.paymentObject['purpose'] = 'Payment for the month ' + item.month + item.year;
        this.paymentObject['totalAmount'] = item.totalBill;
        this.paymentObject['partner'] = item.partner;
        this.paymentObject['partnerEmailId'] = item.partnerEmailId;
        this.paymentObject['partnerPhoneNumber'] = '';
        this.paymentLoading = true;
        this.confPost.payment(this.paymentObject).subscribe(response => {
            this.paymentLoading = true;
            if (response['success']) {
                window.location.href = response['payment_request']['longurl'];
            }
        }, err => {
            this.paymentLoading = true;
            this.platform.openSnackBar('Error while making payment. Please try after sometime or contact support@apiplatform.io', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    proceedWithRazorPay(item, result) {
        this.invoiceId = item.id;
        this.isCreditApplied = result.isCreditApplied;
        this.creditBalanceApplied = result.creditBalanceApplied;
        if (result.isCreditApplied) {
            this.RAZORPAY_OPTIONS.amount = ((item.totalBill - result.creditBalanceApplied) * 83.05).toFixed(0) + '00';
        } else {
            this.RAZORPAY_OPTIONS.amount = (item.totalBill * 83.05).toFixed(0) + '00';
        }
        // this.RAZORPAY_OPTIONS.amount = (100 * 82.85).toFixed(0) + '00';
        this.RAZORPAY_OPTIONS.prefill = {
            name: item.partner,
            email: item.partnerEmailId,
            contact: item.phoneNumber,
            method: ''
        };

        this.RAZORPAY_OPTIONS['handler'] = this.razorPaySuccessHandler.bind(this);
        const razorpay = new Razorpay(this.RAZORPAY_OPTIONS);
        razorpay.open();
    }

    public razorPaySuccessHandler(response: any) {
        // console.log('response', response);
        if (response) {
            const payload = {
                'paymentId': response['razorpay_payment_id'],
                'invoiceId': this.invoiceId,
                'partner': localStorage.getItem('partner'),
                'partnerEmail': localStorage.getItem('signInEmail'),
                'paymentType': 'RazorPay',
                'isCreditApplied': this.isCreditApplied,
                'creditBalanceApplied': this.creditBalanceApplied
            };
            // console.log('payload', payload);
            this.updateInvoice(payload);
        }
        this.cd.detectChanges();
    }

    updateInvoice(payload: any) {
        this.confPost.updateInvoiceStatus(payload).subscribe(res => {
            if (res['message'] === 'payment success') {
                this.platform.openSnackBar('Payment processed successfully.', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                if (res['payment_type'] === 'Stripe') {
                    const payloadForSelectedMonth = {
                        'month': res['month'],
                        'year': res['year'],
                        'partner': this.partner
                    };
                    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'
                    ];
                    this.currentData = monthNames[Number(res['month'])] + ' ' + res['year'];
                    this.payloadForSelectedMonth = payloadForSelectedMonth;
                    const currentUrl = window.location.href;
                    const updatedUrl = currentUrl.replace(/[\?&]session_id=[^&#]*/g, '');
                    window.history.replaceState({}, document.title, updatedUrl);
                }
                this.data = undefined;
                this.getBillingInvoiceData(this.payloadForSelectedMonth);
                this.getInvoiceData();
                this.getCreditsData();
                this.getPaymentData();
            } else {
                this.platform.openSnackBar(res['message'], 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.data = undefined;
                this.getBillingInvoiceData(this.payloadForSelectedMonth);
                this.getInvoiceData();
                this.getCreditsData();
                this.getPaymentData();
            }
        }, err => {
            this.platform.openSnackBar(err['message'], 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    convertTimestamp(timestamp) {

        const unixtimestamp = timestamp;
        const months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        this.date = new Date(unixtimestamp * 1000);
        const year = this.date.getFullYear();
        const month = months_arr[this.date.getMonth()];
        const day = this.date.getDate();
        const hours = this.date.getHours();
        const minutes = '0' + this.date.getMinutes();
        const seconds = '0' + this.date.getSeconds();
        this.lastUpdatedON = month + '-' + day + '-' + year + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
    }

    async getBillingInvoiceData(payload) {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        await this.confPost.getBillingData(payload).toPromise().then(response => {
            loaderDialog.close();
            if (response.status === 200) {
                if (response.body !== null) {
                    this.data = response;

                    if (this.data.body.chartDetails.hasOwnProperty('infrastructureTotalAmount')) {
                        this.barChartLabels.push('Infrastructure');
                    }
                    this.fileStorage = this.data.body.billingDetails.totalStorage.serviceLevelDetails.fileStorage.netAmount.toFixed(2);
                    // this.chartAPICreated = this.data.body.chartDetails['APIsCreatedTotalAmount']['percentage'];
                    this.chartAPIUsage = this.data.body.chartDetails['APIsUsageTotalAmount']['percentage'];
                    this.chartStorage = this.data.body.chartDetails['storageTotalAmount']['percentage'];
                    // if (this.data.body.chartDetails['dataStorageTotalAmount'] !== undefined) {
                    //     this.chartDataStorage = this.data.body.chartDetails['dataStorageTotalAmount']['percentage'];
                    // }
                    // if (this.data.body.chartDetails['dataStorageTotalAmount'] !== undefined) {
                    if (this.data.body.chartDetails.hasOwnProperty('infrastructureTotalAmount') && this.data.body.chartDetails['infrastructureTotalAmount'].hasOwnProperty('percentage')) {
                        this.chartInfrastructure = this.data.body.chartDetails['infrastructureTotalAmount']['percentage'];
                    } else {
                        this.chartInfrastructure = 0;
                    }
                    // }
                    this.total = (this.data.body.accountDetails).length;
                    this.totals = Array(this.total).fill(0).map((x, i) => i);
                    this.subtotalBill = this.data.body.subTotalBill.toFixed(2);
                    if (this.data.body['discountAmount']) {
                        this.discount = this.data.body['discountAmount'].toFixed(2);
                    } else {
                        this.discount = 0;
                    }

                    if (this.data.body['subTotalBillAfterDiscount']) {
                        this.subTotalAfterDiscount = this.data.body.subTotalBillAfterDiscount.toFixed(2);
                    }
                    this.barChartData = [
                        {
                            data: [this.chartAPIUsage, this.chartStorage, this.chartInfrastructure], label: 'Cost',
                            backgroundColor: ['#FF672D', '#2A3F54', '#A9A9A9']
                        }
                    ];

                    if (this.data.body.month !== this.currentMonth) {
                        if (!this.data.body.isPaid) {
                            this.enablePayButton = true;
                        } else {
                            this.enablePayButton = false;
                        }
                    } else {
                        this.enablePayButton = false;
                    }
                } else {
                    this.errorMessage = '0';
                }
            } else {
                this.errorMessage = response.status;
                this.platform.openSnackBar('HTTP Error Code: ' + this.errorMessage + 'Error while fetching Billing Invoice: ' + response.statusText, 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            loaderDialog.close();
            const violation_string = error.toString(),
                timeout_substring = 'Timeout Exceeded';
            if (violation_string.includes(timeout_substring)) {
                this.errorMessage = 'Timeout';
            }
            if (error['status'] === 0) {
                this.errorMessage = '0';
            } else if (error['status'] === 500) {
                this.errorMessage = '0';
            } else if (error['status'] === 400) {
                this.errorMessage = '0';
            }
        });
    }

    async getData(data) {

        this.data = undefined;
        const temp = data.split(' ');
        let monthNumber;

        switch (temp[0]) {
            case 'January': {
                monthNumber = 0;
                break;
            }
            case 'February': {
                monthNumber = 1;
                break;
            }
            case 'March': {
                monthNumber = 2;
                break;
            }
            case 'April': {
                monthNumber = 3;
                break;
            }
            case 'May': {
                monthNumber = 4;
                break;
            }
            case 'June': {
                monthNumber = 5;
                break;
            }
            case 'July': {
                monthNumber = 6;
                break;
            }
            case 'August': {
                monthNumber = 7;
                break;
            }
            case 'September': {
                monthNumber = 8;
                break;
            }
            case 'October': {
                monthNumber = 9;
                break;
            }
            case 'November': {
                monthNumber = 10;
                break;
            }
            case 'December': {
                monthNumber = 11;
                break;
            }
        }
        const payloadForSelectedMonth = {
            'month': monthNumber,
            'year': +temp[1],
            'partner': this.partner
        };

        this.payloadForSelectedMonth = payloadForSelectedMonth;

        this.getBillingInvoiceData(payloadForSelectedMonth);
    }

    public generatePDF() {
        const doc = new jsPDF('p', 'pt', 'a4');
        // tslint:disable-next-line:max-line-length
        const img = 'data:image/png;base64,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';
        doc.addImage(img, 'JPG', 210, 30, 190, 50);
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(1);
        doc.line(40, 100, 560, 100);
        doc.setTextColor(0, 100, 0);
        doc.setFontType('light');
        doc.setFontSize(23);

        doc.setTextColor(255, 103, 45);
        doc.text('INVOICE', 40, 130);
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.setFontType('bold');
        doc.text('Prepared for : ', 265, 113);
        doc.setFontType('light');
        doc.text(this.data.body.partner, 265, 125);
        doc.text(this.data.body.partnerEmailId, 265, 137);
        if (this.data.address1 == null) {
            doc.text('', 400, 125);
        } else {
            doc.text(this.data.body.address1, 400, 125);
        }
        if (this.data.body.address2 == null) {
            doc.text('', 400, 137);
        } else {
            doc.text(this.data.body.address2, 400, 137);
        }

        doc.line(40, 145, 560, 145);
        doc.setFontSize(12);
        doc.text('Invoice #', 40, 190);
        doc.line(40, 195, 155, 195);
        // doc.text('Invoice Date', 170, 190);
        // doc.line(170, 195, 285, 195);
        doc.text('Invoice Month', 300, 190);
        doc.line(300, 195, 425, 195);
        // doc.text('Payment Due', 440, 190);
        // doc.line(440, 195, 560, 195);
        if ('id' in this.data.body) {
            doc.text(this.data.body.id.toString(), 40, 210);

        }
        doc.text('', 40, 210);
        // doc.text('1st ' + (this.data.month + 1) + this.data.year, 170, 210);
        doc.text(this.data.body.monthName + ' ' + this.data.body.year, 300, 210);
        // doc.text('12th ' + this.data.monthName + '2019', 440, 210);

        doc.text('Description', 40, 260);
        // doc.text('Actual Minutes', 225, 260);

        // doc.text('Count', 330, 260);

        doc.text('Quantity', 400, 260);


        // doc.text('Price/Rate', 400, 260);
        doc.text('Amount', 500, 260);
        doc.line(40, 270, 560, 270);
        // doc.text(this.data.partner.apiCreated[0].apiType, 40, 285);
        // doc.text('x' + this.data.partner.apiCreated[0].count, 300, 285);
        // doc.text('$89', 400, 285);
        // doc.text('$' + this.data.partner.apiCreated[0].amount, 500, 285);
        doc.setDrawColor(128, 128, 128);
        doc.setLineWidth(0.3);
        // doc.text('Data Access API - Usage', 40, 285);
        //
        // doc.text('$0.000089', 400, 285);
        // doc.text('$' + this.data.pdfInvoiceDetails.totalDataAccessAPISUsageAmount, 500, 285);
        // doc.line(40, 290, 560, 290);

        // if (this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.isMinutes === true && this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.isHits === false) {
        //     doc.text('API Usage (Active Hours)', 40, 285);
        //     doc.text('Connected Minutes = Total Connected Minutes - Free Tier (' + this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.connectedMinutes.totalAPISConnectedMinutes.toString() + '-800000)' , 40, 305);
        //     doc.text(this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.connectedMinutes.totalAPISConnectedMinutesAfterFreeTier.toString() , 330, 285);
        //     doc.text('$0.0001112', 400, 285);
        //     doc.text('$' + this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.connectedMinutes.amount, 500, 285);
        //     doc.line(40, 310, 560, 310);
        // } else if (this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.isHits === true && this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.isMinutes === false) {
        //     doc.text('API Usage (API hits)', 40, 285);
        //     doc.text('API Hits = Total API hits - Free Tier (' + this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.APIHits.totalAPISHits.toString() + '-1000000)' , 40, 305);
        //     doc.text(this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.APIHits.totalAPISHitsAfterFreeTier.toString() , 330, 285);
        //     doc.text('$0.000089', 400, 285);
        //     doc.text('$' + this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.APIHits.amount, 500, 285);
        //     doc.line(40, 310, 560, 310);
        // } else if (this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.isMinutes === true && this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.isHits === true) {
        //     doc.text('API Usage', 40, 285);
        //     doc.text('Note : Both API hits and connected minutes covered by Free Tier' , 40, 305);
        //     doc.text('0', 330, 285);
        //     doc.text('$0', 400, 285);
        //     doc.text('$0' , 500, 285);
        //     doc.line(40, 310, 560, 310);
        // }


        if (this.data.body.billingPlan === 'PAYG') {
            doc.text('API Usage (Active Hours) (After Free Tier)', 40, 285);
        } else if (this.data.body.billingPlan === 'FIXED') {
            doc.text('API Count (After Free Tier)', 40, 285);
        }

        doc.text(this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.activeHours.description, 40, 305);
        if (this.data.body.billingPlan === 'PAYG') {
            doc.text('x' + this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.activeHours.totalAPIsActiveHoursAfterFreeTier.toString(), 400, 285);
        } else if (this.data.body.billingPlan === 'FIXED') {
            doc.text('x' + this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.activeHours.totalAPIsCountAfterFreeTier.toString(), 400, 285);
        }
        // doc.text('$0.0001112', 400, 285);
        doc.text('$' + this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.activeHours.netAmount, 500, 285);
        doc.line(40, 310, 560, 310);

        //
        doc.text('API Hits (After Free Tier)', 40, 325);
        doc.text('x' + this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.APIHits.totalAPIsHitsAfterFreeTier, 400, 325);
        // doc.text('$10', 400, 325);
        doc.text('$' + this.data.body.billingDetails.totalAPIsUsage.serviceLevelDetails.APIHits.netAmount, 500, 325);
        doc.line(40, 330, 560, 330);
        // //
        // doc.text('API Creation - Business Logic APIs', 40, 345);
        // doc.text('x' + this.data.body.pdfInvoiceDetails.totalBusinessLogicAPISCreated, 330, 345);
        // doc.text('$89', 400, 345);
        // doc.text('$' + this.data.body.pdfInvoiceDetails.totalBusinessLogicAPISCreatedAmount, 500, 345);
        // doc.line(40, 350, 560, 350);
        // //
        //
        // doc.text('API Creation - SQL Query APIs', 40, 365);
        // if (this.data.body.pdfInvoiceDetails.totalSQLQueryAPISCreatedAmount) {
        //     doc.text('x' + this.data.body.pdfInvoiceDetails.totalSQLQueryAPISCreated, 330, 365);
        // } else {
        //     doc.text('x0', 330, 365);
        // }
        // doc.text('$20', 400, 365);
        // if (this.data.body.pdfInvoiceDetails.totalSQLQueryAPISCreatedAmount) {
        //     doc.text('$' + this.data.body.pdfInvoiceDetails.totalSQLQueryAPISCreatedAmount, 500, 365);
        // } else {
        //     doc.text('$' + 0, 500, 365);
        // }
        // doc.line(40, 370, 560, 370);

        // if (this.data.body.billingDetails.dataStorageAmount) {
        doc.text('Data Storage (GB)', 40, 345);
        doc.text('x' + this.data.body.billingDetails.totalStorage.serviceLevelDetails.dataStorage.totalDataStorage.toFixed(4), 400, 345);
        // doc.text('$89', 400, 365);
        doc.text('$' + this.data.body.billingDetails.totalStorage.serviceLevelDetails.dataStorage.netAmount, 500, 345);
        doc.line(40, 350, 560, 350);
        // }

        doc.text('File Storage (GB)', 40, 365);
        doc.text('x' + this.data.body.billingDetails.totalStorage.serviceLevelDetails.fileStorage.totalFileStorage.toFixed(4), 400, 365);
        // doc.text('$89', 400, 365);
        doc.text('$' + this.data.body.billingDetails.totalStorage.serviceLevelDetails.fileStorage.netAmount, 500, 365);
        // doc.line(40, 370, 560, 370);
        doc.text('Note : ' + this.data.body.billingDetails.totalStorage.serviceLevelDetails.fileStorage.description, 40, 395);
        doc.line(40, 400, 560, 400);


        // if (this.data['body']['partnerAccounts'][0]['infrastructure']) {
        //     if (this.data['body']['partnerAccounts'][0]['infrastructure']['totalAmount'] > 0) {
        //         doc.text('Infrastructure - MongoDB', 40, 445);
        //         // doc.text( 'x' + this.data.body.billingDetails.dataStorageAmount.totalDataStorage.toFixed(4) + ' GB', 330, 445);
        //         // doc.text('$89', 400, 365);
        //         doc.text('$' + this.data.body.billingDetails.totalInfrastructure.serviceLevelDetails.MongoDB.netAmount, 500, 445);
        //         doc.line(40, 450, 560, 450);
        //
        //         doc.text('Infrastructure - Amazon Web Services (AWS)', 40, 465);
        //         // doc.text( 'x' + this.data.body.billingDetails.dataStorageAmount.totalDataStorage.toFixed(4) + ' GB', 330, 445);
        //         // doc.text('$89', 400, 365);
        //         doc.text('$' + this.data.body.billingDetails.totalInfrastructure.serviceLevelDetails.AWS.netAmount, 500, 465);
        //         doc.line(40, 470, 560, 470);
        // }
        // }

        //
        doc.text('Gross Total', 400, 420);
        // doc.line(500, 495, 560, 495);
        doc.text('$' + this.data.body.subTotalBill.toFixed(2), 500, 420);

        if (this.discount > 0) {
            doc.line(300, 445, 560, 445);
            doc.text('Strategic Partnership Offer', 330, 460);
            doc.setTextColor(255, 103, 45);
            doc.text('- $' + this.discount, 495, 460);
            doc.setTextColor(0, 0, 0);
        }

        doc.line(400, 465, 560, 465);
        doc.text('Tax ( ' + this.data.body.taxPercentage + ' % )', 400, 480);
        doc.line(400, 490, 560, 490);
        doc.text('$' + this.data.body.tax.toString(), 500, 480);

        doc.text('Net Total', 400, 515);
        doc.line(400, 525, 560, 525);
        doc.text('$' + (this.data.body.totalBill).toFixed(2), 500, 515);


        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(1);
        doc.text('Terms & Conditions', 40, 680);
        // doc.text('Total Amount Due', 480, 600);
        doc.line(40, 690, 560, 690);
        doc.setFontSize(8);
        doc.text('Thanks for using apiplatform.io Cloud Products! These apiplatform.io Cloud Terms \nof Service (these"Terms")") describe your rights and responsibilities as a customer \nof our Cloud Products.As applicable to the specific Cloud Product,if you are being\n invited or added to a Cloud Product set up by a apiplatform.io customer, the User\n Notice governs your access and use of the Cloud Product (and not these Terms).', 40, 705);
        // doc.setTextColor(255, 103, 45);
        // doc.setFontSize(22);
        // doc.text('$' + (this.data.totalAmount + (this.data.totalAmount * 16 / 100)).toFixed(2), 420, 605);
        // doc.text('$' + (this.data.body.totalBill).toFixed(2), 470, 640);
        doc.setTextColor(0, 0, 0);

        doc.setFontSize(12);
        doc.line(40, 755, 560, 755);

        doc.text('Contact Details', 40, 770);
        doc.setFontSize(9);
        doc.text('sales@apiplatform.io', 45, 783);
        doc.text('+1 914 318 5546', 45, 795);

        doc.text('244 E Rocks Rd, Norwalk,', 230, 783);
        doc.text('Connecticut, USA - 06851', 230, 795);

        // doc.text('apiplatform.io', 430, 783);
        // doc.text('apiplatform.io', 430, 795);

        doc.line(40, 803, 560, 803);
        doc.text('This is an electronically generated statement and does not require any signature', 40, 813);
        doc.output('dataurlnewwindow');
    }

    public generatePDF1(item: any) {
        const doc = new jsPDF('p', 'pt', 'a4');
        // tslint:disable-next-line:max-line-length
        const img = 'data:image/png;base64,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';
        doc.addImage(img, 'JPG', 210, 30, 190, 50);
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(1);
        doc.line(40, 100, 560, 100);
        doc.setTextColor(0, 100, 0);
        doc.setFontType('light');
        doc.setFontSize(23);

        doc.setTextColor(255, 103, 45);
        doc.text('INVOICE', 40, 130);
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.setFontType('bold');
        doc.text('Prepared for : ', 265, 113);
        doc.setFontType('light');
        doc.text(item.partner, 265, 125);
        doc.text(item.partnerEmailId, 265, 137);
        if (item.address1 == null) {
            doc.text('', 400, 125);
        } else {
            doc.text(item.address1, 400, 125);
        }
        if (item.address2 == null) {
            doc.text('', 400, 137);
        } else {
            doc.text(item.address2, 400, 137);
        }

        doc.line(40, 145, 560, 145);
        doc.setFontSize(12);
        doc.text('Invoice #', 40, 190);
        doc.line(40, 195, 155, 195);
        // doc.text('Invoice Date', 170, 190);
        // doc.line(170, 195, 285, 195);
        doc.text('Invoice Month', 300, 190);
        doc.line(300, 195, 425, 195);
        // doc.text('Payment Due', 440, 190);
        // doc.line(440, 195, 560, 195);
        if ('id' in item) {
            doc.text(item.id.toString(), 40, 210);

        }
        doc.text('', 40, 210);
        // doc.text('1st ' + (item.month + 1) + item.year, 170, 210);
        doc.text(item.monthName + ' ' + item.year, 300, 210);
        // doc.text('12th ' + item.monthName + '2019', 440, 210);

        doc.text('Description', 40, 260);
        // doc.text('Actual Minutes', 225, 260);

        // doc.text('Count', 330, 260);

        doc.text('Quantity', 400, 260);


        // doc.text('Price/Rate', 400, 260);
        doc.text('Amount', 500, 260);
        doc.line(40, 270, 560, 270);
        // doc.text(item.partner.apiCreated[0].apiType, 40, 285);
        // doc.text('x' + item.partner.apiCreated[0].count, 300, 285);
        // doc.text('$89', 400, 285);
        // doc.text('$' + item.partner.apiCreated[0].amount, 500, 285);
        doc.setDrawColor(128, 128, 128);
        doc.setLineWidth(0.3);
        // doc.text('Data Access API - Usage', 40, 285);
        //
        // doc.text('$0.000089', 400, 285);
        // doc.text('$' + item.pdfInvoiceDetails.totalDataAccessAPISUsageAmount, 500, 285);
        // doc.line(40, 290, 560, 290);

        // if (item.billingDetails.totalAPIsUsage.serviceLevelDetails.isMinutes === true && item.billingDetails.totalAPIsUsage.serviceLevelDetails.isHits === false) {
        //     doc.text('API Usage (Active Hours)', 40, 285);
        //     doc.text('Connected Minutes = Total Connected Minutes - Free Tier (' + item.billingDetails.totalAPIsUsage.serviceLevelDetails.connectedMinutes.totalAPISConnectedMinutes.toString() + '-800000)' , 40, 305);
        //     doc.text(item.billingDetails.totalAPIsUsage.serviceLevelDetails.connectedMinutes.totalAPISConnectedMinutesAfterFreeTier.toString() , 330, 285);
        //     doc.text('$0.0001112', 400, 285);
        //     doc.text('$' + item.billingDetails.totalAPIsUsage.serviceLevelDetails.connectedMinutes.amount, 500, 285);
        //     doc.line(40, 310, 560, 310);
        // } else if (item.billingDetails.totalAPIsUsage.serviceLevelDetails.isHits === true && item.billingDetails.totalAPIsUsage.serviceLevelDetails.isMinutes === false) {
        //     doc.text('API Usage (API hits)', 40, 285);
        //     doc.text('API Hits = Total API hits - Free Tier (' + item.billingDetails.totalAPIsUsage.serviceLevelDetails.APIHits.totalAPISHits.toString() + '-1000000)' , 40, 305);
        //     doc.text(item.billingDetails.totalAPIsUsage.serviceLevelDetails.APIHits.totalAPISHitsAfterFreeTier.toString() , 330, 285);
        //     doc.text('$0.000089', 400, 285);
        //     doc.text('$' + item.billingDetails.totalAPIsUsage.serviceLevelDetails.APIHits.amount, 500, 285);
        //     doc.line(40, 310, 560, 310);
        // } else if (item.billingDetails.totalAPIsUsage.serviceLevelDetails.isMinutes === true && item.billingDetails.totalAPIsUsage.serviceLevelDetails.isHits === true) {
        //     doc.text('API Usage', 40, 285);
        //     doc.text('Note : Both API hits and connected minutes covered by Free Tier' , 40, 305);
        //     doc.text('0', 330, 285);
        //     doc.text('$0', 400, 285);
        //     doc.text('$0' , 500, 285);
        //     doc.line(40, 310, 560, 310);
        // }


        if (item.billingPlan === 'PAYG') {
            doc.text('API Usage (Active Hours) (After Free Tier)', 40, 285);
        } else if (item.billingPlan === 'FIXED') {
            doc.text('API Count (After Free Tier)', 40, 285);
        }

        doc.text(item.billingDetails.totalAPIsUsage.serviceLevelDetails.activeHours.description, 40, 305);
        if (item.billingPlan === 'PAYG') {
            doc.text('x' + item.billingDetails.totalAPIsUsage.serviceLevelDetails.activeHours.totalAPIsActiveHoursAfterFreeTier.toString(), 400, 285);
        } else if (item.billingPlan === 'FIXED') {
            doc.text('x' + item.billingDetails.totalAPIsUsage.serviceLevelDetails.activeHours.totalAPIsCountAfterFreeTier.toString(), 400, 285);
        }
        // doc.text('$0.0001112', 400, 285);
        doc.text('$' + item.billingDetails.totalAPIsUsage.serviceLevelDetails.activeHours.netAmount, 500, 285);
        doc.line(40, 310, 560, 310);

        //
        doc.text('API Hits (After Free Tier)', 40, 325);
        doc.text('x' + item.billingDetails.totalAPIsUsage.serviceLevelDetails.APIHits.totalAPIsHitsAfterFreeTier, 400, 325);
        // doc.text('$10', 400, 325);
        doc.text('$' + item.billingDetails.totalAPIsUsage.serviceLevelDetails.APIHits.netAmount, 500, 325);
        doc.line(40, 330, 560, 330);
        // //
        // doc.text('API Creation - Business Logic APIs', 40, 345);
        // doc.text('x' + item.pdfInvoiceDetails.totalBusinessLogicAPISCreated, 330, 345);
        // doc.text('$89', 400, 345);
        // doc.text('$' + item.pdfInvoiceDetails.totalBusinessLogicAPISCreatedAmount, 500, 345);
        // doc.line(40, 350, 560, 350);
        // //
        //
        // doc.text('API Creation - SQL Query APIs', 40, 365);
        // if (item.pdfInvoiceDetails.totalSQLQueryAPISCreatedAmount) {
        //     doc.text('x' + item.pdfInvoiceDetails.totalSQLQueryAPISCreated, 330, 365);
        // } else {
        //     doc.text('x0', 330, 365);
        // }
        // doc.text('$20', 400, 365);
        // if (item.pdfInvoiceDetails.totalSQLQueryAPISCreatedAmount) {
        //     doc.text('$' + item.pdfInvoiceDetails.totalSQLQueryAPISCreatedAmount, 500, 365);
        // } else {
        //     doc.text('$' + 0, 500, 365);
        // }
        // doc.line(40, 370, 560, 370);

        // if (item.billingDetails.dataStorageAmount) {
        doc.text('Data Storage (GB)', 40, 345);
        doc.text('x' + item.billingDetails.totalStorage.serviceLevelDetails.dataStorage.totalDataStorage.toFixed(4), 400, 345);
        // doc.text('$89', 400, 365);
        doc.text('$' + item.billingDetails.totalStorage.serviceLevelDetails.dataStorage.netAmount, 500, 345);
        doc.line(40, 350, 560, 350);
        // }

        doc.text('File Storage (GB)', 40, 365);
        doc.text('x' + item.billingDetails.totalStorage.serviceLevelDetails.fileStorage.totalFileStorage.toFixed(4), 400, 365);
        // doc.text('$89', 400, 365);
        doc.text('$' + item.billingDetails.totalStorage.serviceLevelDetails.fileStorage.netAmount, 500, 365);
        // doc.line(40, 370, 560, 370);
        doc.text('Note : ' + item.billingDetails.totalStorage.serviceLevelDetails.fileStorage.description, 40, 395);
        doc.line(40, 400, 560, 400);


        // if (item['body']['partnerAccounts'][0]['infrastructure']) {
        //     if (item['body']['partnerAccounts'][0]['infrastructure']['totalAmount'] > 0) {
        //         doc.text('Infrastructure - MongoDB', 40, 445);
        //         // doc.text( 'x' + item.billingDetails.dataStorageAmount.totalDataStorage.toFixed(4) + ' GB', 330, 445);
        //         // doc.text('$89', 400, 365);
        //         doc.text('$' + item.billingDetails.totalInfrastructure.serviceLevelDetails.MongoDB.netAmount, 500, 445);
        //         doc.line(40, 450, 560, 450);
        //
        //         doc.text('Infrastructure - Amazon Web Services (AWS)', 40, 465);
        //         // doc.text( 'x' + item.billingDetails.dataStorageAmount.totalDataStorage.toFixed(4) + ' GB', 330, 445);
        //         // doc.text('$89', 400, 365);
        //         doc.text('$' + item.billingDetails.totalInfrastructure.serviceLevelDetails.AWS.netAmount, 500, 465);
        //         doc.line(40, 470, 560, 470);
        // }
        // }

        //
        doc.text('Gross Total', 400, 420);
        // doc.line(500, 495, 560, 495);
        doc.text('$' + item.subTotalBill.toFixed(2), 500, 420);

        if (this.discount > 0) {
            doc.line(300, 445, 560, 445);
            doc.text('Strategic Partnership Offer', 330, 460);
            doc.setTextColor(255, 103, 45);
            doc.text('- $' + this.discount, 495, 460);
            doc.setTextColor(0, 0, 0);
        }

        doc.line(400, 465, 560, 465);
        doc.text('Tax ( ' + item.taxPercentage + ' % )', 400, 480);
        doc.line(400, 490, 560, 490);
        doc.text('$' + item.tax.toString(), 500, 480);

        doc.text('Net Total', 400, 515);
        doc.line(400, 525, 560, 525);
        doc.text('$' + (item.totalBill).toFixed(2), 500, 515);


        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(1);
        doc.text('Terms & Conditions', 40, 680);
        // doc.text('Total Amount Due', 480, 600);
        doc.line(40, 690, 560, 690);
        doc.setFontSize(8);
        doc.text('Thanks for using apiplatform.io Cloud Products! These apiplatform.io Cloud Terms \nof Service (these"Terms")") describe your rights and responsibilities as a customer \nof our Cloud Products.As applicable to the specific Cloud Product,if you are being\n invited or added to a Cloud Product set up by a apiplatform.io customer, the User\n Notice governs your access and use of the Cloud Product (and not these Terms).', 40, 705);
        // doc.setTextColor(255, 103, 45);
        // doc.setFontSize(22);
        // doc.text('$' + (item.totalAmount + (item.totalAmount * 16 / 100)).toFixed(2), 420, 605);
        // doc.text('$' + (item.totalBill).toFixed(2), 470, 640);
        doc.setTextColor(0, 0, 0);

        doc.setFontSize(12);
        doc.line(40, 755, 560, 755);

        doc.text('Contact Details', 40, 770);
        doc.setFontSize(9);
        doc.text('sales@apiplatform.io', 45, 783);
        doc.text('+1 914 318 5546', 45, 795);

        doc.text('244 E Rocks Rd, Norwalk,', 230, 783);
        doc.text('Connecticut, USA - 06851', 230, 795);

        // doc.text('apiplatform.io', 430, 783);
        // doc.text('apiplatform.io', 430, 795);

        doc.line(40, 803, 560, 803);
        doc.text('This is an electronically generated statement and does not require any signature', 40, 813);
        doc.output('dataurlnewwindow');
    }

    viewPayBtn(item): any {
        if (item.isPaid || (this.currentMonth === item.month && this.currentYear === item.year)) {
            return false;
        }
        return true;
    }

    IsSelectedView(id) {
        if (id === this.selectedView) {
            return 'rgb(245, 245, 245)';
        }
    }

    getDateFrmt1(time) {
        const date = new Date(time);
        return date.toLocaleString();
    }

    getDateFrmt(item) {
        if (item.payment_type === 'RazorPay') {
            const milliseconds = Number(item.created_at) * 1000;
            const date = new Date(milliseconds);
            return date.toLocaleString();
        } else if (item.payment_type === 'Paypal') {
            const dateObject = new Date(item.created_at);
            const formattedDate = `${String(dateObject.getDate()).padStart(2, '0')}/${String(dateObject.getMonth() + 1).padStart(2, '0')}/${dateObject.getFullYear()}`;
            const formattedTime = `${String(dateObject.getHours()).padStart(2, '0')}:${String(dateObject.getMinutes()).padStart(2, '0')}:${String(dateObject.getSeconds()).padStart(2, '0')}`;
            const result = `${formattedDate}, ${formattedTime}`;
            return result;
        } else if (item.payment_type === 'Stripe') {
            const date = new Date(Number(item.created_at) * 1000);
            const year = date.getFullYear();
            const month = ('0' + (date.getMonth() + 1)).slice(-2); // Months are zero-indexed, so we add 1
            const day = ('0' + date.getDate()).slice(-2);
            const hours = ('0' + date.getHours()).slice(-2);
            const minutes = ('0' + date.getMinutes()).slice(-2);
            const seconds = ('0' + date.getSeconds()).slice(-2);
            const formattedDateTime = day + '/' + month + '/' + year + ', ' + hours + ':' + minutes + ':' + seconds;
            return formattedDateTime;
        }
        return item.created_at;
    }


    getAmount(item) {
        if (item.payment_type === 'RazorPay') {
            return (Number(item.amount) / 100).toFixed(2);
        }
        return item.amount;
    }

    choosePayment(item: any) {
        this.invoiceId = item.id;
        const dialogRef = this.dialog.open(ChoosePaymentDialog, {
            width: '30vw',
            maxWidth: '30vw',
            data: {
                'billingData': item,
                'creditData': this.creditsData
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.method === 'RazorPay') {
                this.proceedWithRazorPay(result.data, result);
            } else if (result && result.method === 'Stripe') {
                // this.makePayment(result.data.totalBill);
                this.isCreditApplied = result.isCreditApplied;
                this.creditBalanceApplied = result.creditBalanceApplied;
                this.paymentUsingStrip(result.data, result);
            } else if (result && result.method === 'Paypal') {
                if (result.data && result.data.paymentId) {
                    this.isCreditApplied = result.isCreditApplied;
                    this.creditBalanceApplied = result.creditBalanceApplied;
                    const payload = {
                        'paymentId': result.data.paymentId,
                        'invoiceId': this.invoiceId,
                        'partner': localStorage.getItem('partner'),
                        'partnerEmail': localStorage.getItem('signInEmail'),
                        'paymentType': 'Paypal',
                        'isCreditApplied': this.isCreditApplied,
                        'creditBalanceApplied': this.creditBalanceApplied
                    };
                    this.updateInvoice(payload);
                }

            }
        });
    }

    paymentUsingStrip(item, result) {
        this.invoiceId = item.id;
        this.isCreditApplied = result.isCreditApplied;
        this.creditBalanceApplied = result.creditBalanceApplied;
        let amount = 0;
        if (result.isCreditApplied) {
            amount = Math.floor((item.totalBill - result.creditBalanceApplied) * 100);
        } else {
            amount = Math.floor(item.totalBill * 100);
        }
        const stripe_payload = {
            amount: amount,
            month: item.month,
            year: item.year,
            partner: item.environmentName,
            invoiceId: this.invoiceId,
            success_url: window.location.href + '?session_id={CHECKOUT_SESSION_ID}'
        };
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.confPost.createStripePaymentLink(stripe_payload).subscribe(res => {
            loaderDialog.close();
            if (res && res['message'] === 'success') {
                this.stripeSessionId = res['data']['id'];
                this.stripePaymentLink = res['data']['url'];
                if (this.stripeSessionId && this.stripePaymentLink !== '') {
                    window.open(this.stripePaymentLink);
                }
            }
        }, error => {
            loaderDialog.close();
        });
    }

    // async checkout() {
    //     // Call your backend to create the Checkout session.
    //
    //     // When the customer clicks on the button, redirect them to Checkout.
    //     const stripe = await this.stripePromise;
    //     const error = await stripe?.redirectToCheckout({
    //         mode: 'payment',
    //         lineItems: [{price: this.priceId, quantity: this.quantity}],
    //         successUrl: `${window.location.href}/success`,
    //         cancelUrl: `${window.location.href}/failure`,
    //     });
    //     // If `redirectToCheckout` fails due to a browser or network
    //     // error, display the localized error message to your customer
    //     // using `error.message`.
    //     if (error) {
    //         console.log(error);
    //     }
    //
    // }


    makePayment(amount: any) {
        const paymentHandler = (<any>window).StripeCheckout.configure({
            key: 'pk_test_51NqAWwSCTsCJbf1bHMAzcrLPzi7dW9neUa9j65kxU2tdMqaJFo4HJai5yhbOXCmdo3u6AvD5dif3vbfE6uuARAhv00MpoaxV4o',
            locale: 'auto',
            token: (stripeToken: any) => {
                // console.log(stripeToken);
                alert('Stripe Payment Success..!');
                this.updatePayment(stripeToken);
            },
        });
        paymentHandler.open({
            name: 'apiplatform.io',
            description: 'LINX WORKS PRIVATE LIMITED',
            amount: amount * 100,
        });
    }

    updatePayment(item: any) {
        const payload = {
            'paymentId': item['id'],
            'invoiceId': this.invoiceId,
            'partner': localStorage.getItem('partner')
        };
        // console.log(payload);
        // this.confPost.updateInvoiceStatus(payload).subscribe(res => {
        //     if (res['message'] === 'success') {
        //         this.platform.openSnackBar('Payment processed successfully.', 'Success', {
        //             duration: 5000,
        //             verticalPosition: 'top',
        //             horizontalPosition: 'center'
        //         });
        //         this.data = undefined;
        //         this.getBillingInvoiceData(this.payloadForSelectedMonth);
        //         this.getInvoiceData();
        //         this.getCreditsData();
        //         this.getPaymentData();
        //     } else {
        //         this.platform.openSnackBar(res['message'], 'Error', {
        //             duration: 5000,
        //             verticalPosition: 'top',
        //             horizontalPosition: 'center'
        //         });
        //     }
        // });
    }

    invokeStripe() {
        if (!window.document.getElementById('stripe-script')) {
            const script = window.document.createElement('script');
            script.id = 'stripe-script';
            script.type = 'text/javascript';
            script.src = 'https://checkout.stripe.com/checkout.js';
            script.onload = () => {
                this.paymentHandler = (<any>window).StripeCheckout.configure({
                    key: 'pk_test_51NqAWwSCTsCJbf1bHMAzcrLPzi7dW9neUa9j65kxU2tdMqaJFo4HJai5yhbOXCmdo3u6AvD5dif3vbfE6uuARAhv00MpoaxV4o',
                    locale: 'auto',
                    token: function (stripeToken: any) {
                        // console.log(stripeToken);
                        alert('Payment has been successfull!');
                    },
                });
            };
            window.document.body.appendChild(script);
        }
    }
}


@Component({
    selector: 'choosePayment',
    templateUrl: 'choose-payment.html',
    styleUrls: ['choose-payment.css'],
})
export class ChoosePaymentDialog {
    isCreditApplied = false;
    public payPalConfig?: IPayPalConfig;
    creditBalanceApplied: any = 0;
    creditBalanceCanBeApplied: any = 0;
    creditBalance = 0;
    billAmount: any = 0;

    constructor(public dialogRef: MatDialogRef<ChoosePaymentDialog>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) {
        dialogRef.disableClose = true;
        this.billAmount = this.data.billingData.totalBill;
        if (this.data.creditData && this.data.creditData.length > 0 && this.data.creditData[0].hasOwnProperty('creditBalance')) {
            this.creditBalance = this.data.creditData[0]['creditBalance'];
        }
        if (this.creditBalance > 0) {
            const discountAmount = (this.data.billingData.totalBill * 10) / 100;
            if (discountAmount < this.creditBalance) {
                this.creditBalanceCanBeApplied = discountAmount.toFixed(2);
            } else {
                this.creditBalanceCanBeApplied = this.creditBalance.toFixed(2);
            }
        }
        const totalBill = this.data.billingData.totalBill;
        this.payPalConfig = {
            currency: 'USD',
            clientId: 'AaYHx1WSH7cvWBDtpy4534KZtKmEy1pliLZHFzCQsSE0SVp_-od8rlL-RKHumw9CL4WEnjZwFoIOikM7',
            createOrderOnClient: (data1) => <ICreateOrderRequest>{
                intent: 'CAPTURE',
                purchase_units: [
                    {
                        amount: {
                            currency_code: 'USD',
                            value: totalBill.toString(),
                            breakdown: {
                                item_total: {
                                    currency_code: 'USD',
                                    value: totalBill.toString()
                                }
                            }
                        },
                        items: [
                            {
                                name: 'Enterprise Subscription',
                                quantity: '1',
                                category: 'DIGITAL_GOODS',
                                unit_amount: {
                                    currency_code: 'USD',
                                    value: totalBill.toString(),
                                },
                            }
                        ]
                    }
                ]
            },
            advanced: {
                commit: 'true'
            },
            style: {
                layout: 'horizontal',
                color: 'blue',
                shape: 'rect',
                label: 'paypal',
            },
            onApprove: (data1: any, actions: any) => {
                // console.log('onApprove - transaction was approved, but not authorized', data1, actions);
                actions.order.get().then((details: any) => {
                    // console.log('onApprove - you can get full order details inside onApprove: ', details);
                });
            },
            onClientAuthorization: (data1: any) => {
                // console.log(' on successful transaction', data1);
                // this.showSuccess = true;
                const dialogRef1 = this.dialog.open(PaymentConfirmationDialog, {
                    width: '40vw',
                    height: '95vh',
                    maxHeight: '95vh',
                    maxWidth: '40vw',
                    data: data1
                });

                dialogRef1.afterClosed().subscribe(result => {
                    if (result) {
                        this.dialogRef.close({
                            method: 'Paypal', data: result, isCreditApplied: this.isCreditApplied,
                            creditBalanceApplied: this.creditBalanceApplied
                        });
                    }
                });
            },
            onCancel: (data1: any, actions: any) => {
                // console.log('OnCancel', data1, actions);
            },
            onError: (err: any) => {
                // console.log('OnError', err);
            },
            onClick: (data1: any, actions: any) => {
                // console.log('onClick', data1, actions);
            },
        };
    }

    onChanage() {
        let totalBill = this.data.billingData.totalBill;
        if (this.isCreditApplied) {
            this.creditBalanceApplied = this.creditBalanceCanBeApplied;
            totalBill = (totalBill - this.creditBalanceApplied).toFixed(2);
            this.payPalConfig = {
                currency: 'USD',
                clientId: 'AaYHx1WSH7cvWBDtpy4534KZtKmEy1pliLZHFzCQsSE0SVp_-od8rlL-RKHumw9CL4WEnjZwFoIOikM7',
                createOrderOnClient: (data1) => <ICreateOrderRequest>{
                    intent: 'CAPTURE',
                    purchase_units: [
                        {
                            amount: {
                                currency_code: 'USD',
                                value: totalBill.toString(),
                                breakdown: {
                                    item_total: {
                                        currency_code: 'USD',
                                        value: totalBill.toString()
                                    }
                                }
                            },
                            items: [
                                {
                                    name: 'Enterprise Subscription',
                                    quantity: '1',
                                    category: 'DIGITAL_GOODS',
                                    unit_amount: {
                                        currency_code: 'USD',
                                        value: totalBill.toString(),
                                    },
                                }
                            ]
                        }
                    ]
                },
                advanced: {
                    commit: 'true'
                },
                style: {
                    layout: 'horizontal',
                    color: 'blue',
                    shape: 'rect',
                    label: 'paypal',
                },
                onApprove: (data1: any, actions: any) => {
                    // console.log('onApprove - transaction was approved, but not authorized', data1, actions);
                    actions.order.get().then((details: any) => {
                        // console.log('onApprove - you can get full order details inside onApprove: ', details);
                    });
                },
                onClientAuthorization: (data1: any) => {
                    // console.log(' on successful transaction', data1);
                    // this.showSuccess = true;
                    const dialogRef1 = this.dialog.open(PaymentConfirmationDialog, {
                        width: '40vw',
                        height: '95vh',
                        maxHeight: '95vh',
                        maxWidth: '40vw',
                        data: data1
                    });

                    dialogRef1.afterClosed().subscribe(result => {
                        if (result) {
                            this.dialogRef.close({
                                method: 'Paypal',
                                data: result,
                                isCreditApplied: this.isCreditApplied,
                                creditBalanceApplied: this.creditBalanceApplied
                            });
                        }
                    });
                },
                onCancel: (data1: any, actions: any) => {
                    // console.log('OnCancel', data1, actions);
                },
                onError: (err: any) => {
                    // console.log('OnError', err);
                },
                onClick: (data1: any, actions: any) => {
                    // console.log('onClick', data1, actions);
                },
            };
        } else {
            this.creditBalanceApplied = 0;
            this.payPalConfig = {
                currency: 'USD',
                clientId: 'AaYHx1WSH7cvWBDtpy4534KZtKmEy1pliLZHFzCQsSE0SVp_-od8rlL-RKHumw9CL4WEnjZwFoIOikM7',
                createOrderOnClient: (data1) => <ICreateOrderRequest>{
                    intent: 'CAPTURE',
                    purchase_units: [
                        {
                            amount: {
                                currency_code: 'USD',
                                value: totalBill.toString(),
                                breakdown: {
                                    item_total: {
                                        currency_code: 'USD',
                                        value: totalBill.toString()
                                    }
                                }
                            },
                            items: [
                                {
                                    name: 'Enterprise Subscription',
                                    quantity: '1',
                                    category: 'DIGITAL_GOODS',
                                    unit_amount: {
                                        currency_code: 'USD',
                                        value: totalBill.toString(),
                                    },
                                }
                            ]
                        }
                    ]
                },
                advanced: {
                    commit: 'true'
                },
                style: {
                    layout: 'horizontal',
                    color: 'blue',
                    shape: 'rect',
                    label: 'paypal',
                },
                onApprove: (data1: any, actions: any) => {
                    // console.log('onApprove - transaction was approved, but not authorized', data1, actions);
                    actions.order.get().then((details: any) => {
                        // console.log('onApprove - you can get full order details inside onApprove: ', details);
                    });
                },
                onClientAuthorization: (data1: any) => {
                    // console.log(' on successful transaction', data1);
                    // this.showSuccess = true;
                    const dialogRef1 = this.dialog.open(PaymentConfirmationDialog, {
                        width: '40vw',
                        height: '95vh',
                        maxHeight: '95vh',
                        maxWidth: '40vw',
                        data: data1
                    });

                    dialogRef1.afterClosed().subscribe(result => {
                        if (result) {
                            this.dialogRef.close({
                                method: 'Paypal',
                                data: result,
                                isCreditApplied: this.isCreditApplied,
                                creditBalanceApplied: this.creditBalanceApplied
                            });
                        }
                    });
                },
                onCancel: (data1: any, actions: any) => {
                    // console.log('OnCancel', data1, actions);
                },
                onError: (err: any) => {
                    // console.log('OnError', err);
                },
                onClick: (data1: any, actions: any) => {
                    // console.log('onClick', data1, actions);
                },
            };
        }
    }

    paymentUsingRazorPay() {
        this.dialogRef.close({
            method: 'RazorPay',
            data: this.data.billingData,
            isCreditApplied: this.isCreditApplied,
            creditBalanceApplied: this.creditBalanceApplied
        });
    }

    paymentUsingStripe() {
        this.dialogRef.close({
            method: 'Stripe',
            data: this.data.billingData,
            isCreditApplied: this.isCreditApplied,
            creditBalanceApplied: this.creditBalanceApplied
        });
    }

    close() {
        this.dialogRef.close();
    }
}


@Component({
    selector: 'payment-confirmation',
    templateUrl: 'payment-confirmation.html',
    styleUrls: ['payment-confirmation.css'],
})
export class PaymentConfirmationDialog {


    constructor(public dialogRef: MatDialogRef<PaymentConfirmationDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        dialogRef.disableClose = true;
    }

    close() {
        this.dialogRef.close({ paymentId: this.data.purchase_units[0].payments.captures[0].id });
    }
}
